const FontFamilyMaterialMUI = {
  AmericanTypewriter: 'American Typewriter',
  Arial: 'Arial',
  ArialBalck: 'Arial Black',
  BradleyHand: 'Bradley Hand',
  BrushScriptMT: 'Brush Script MT',
  Cambria: 'Cambria',
  Courier: 'Courier',
  ComicSansMS: 'Comic Sans MS',
  Didot: 'Didot',
  Georgia: 'Georgia',
  Helvetica: 'Helvetica',
  HelveticaNeue: 'Helvetica Neue',
  LucidaConsole: 'Lucida Console',
  Luminari: 'Luminari',
  Monaco: 'Monaco',
  Roboto: 'Roboto',
  Tahoma: 'Tahoma',
  TimesNewRoman: 'Times New Roman',
  Verdana: 'Verdana'
};

export default FontFamilyMaterialMUI;
